import { makeStyles } from 'tss-react/mui';

const name = 'ChainProjects';

export const useChanProjectsStyles = makeStyles({ name })(theme => ({
  root: {
    paddingRight: theme.spacing(1),
    marginRight: 'auto',
    display: 'flex',
    gap: theme.spacing(2),
    overflow: 'hidden',
  },
}));
